import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Missing access token.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    let message = "Failed to process request.";
    try {
      const payload = await response.json();
      if (payload?.detail) {
        message = payload.detail;
      } else if (typeof payload === "object") {
        message = Object.values(payload)
          .map((value) => (Array.isArray(value) ? value.join(" ") : value))
          .join(" ");
      }
    } catch (_err) {
      // ignore parse errors
    }
    throw new Error(message);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

export const fetchMyMemberships = async () => {
  const resp = await fetch(`${domain}profiles/my-memberships/`, {
    method: "GET",
    headers: authHeaders(),
  });
  return handleResponse(resp);
};

export const activateMembership = async (memberId) => {
  const resp = await fetch(`${domain}profiles/select-membership/`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ member_id: memberId }),
  });
  return handleResponse(resp);
};
